import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IBaseSiteOpeningHours } from '../../../interfaces/customer-sites';
import moment from 'moment/moment';
import { computed } from 'mobx-angular';
import { WarningContainerComponent } from '../warning-container/warning-container.component';

@Component({
  selector: 'app-booking-warnings',
  standalone: true,
  imports: [CommonModule, WarningContainerComponent],
  templateUrl: './booking-warnings.component.html',
  styleUrls: ['./booking-warnings.component.scss'],
})
export class BookingWarningsComponent implements OnInit, OnChanges {
  protected showOpenHoursWarning: boolean = false;
  protected showStandardHoursWarning: boolean = false;

  private _earliest: Date | null = null;
  private _latest: Date | null = null;

  @Input() openHours: IBaseSiteOpeningHours[] = [];

  @Input() routeTime: number = 0;
  @Input() createOrderDefaultLatestDropoffHour: number = 17;

  @Input() set earliest(value: string | Date) {
    this._earliest = this.ensureDate(value);
  }

  @Input() set latest(value: string | Date) {
    this._latest = this.ensureDate(value);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['openHours'] || changes['earliest'] || changes['latest'] || changes['routeTime']) {
      this.checkWarning();
    }
  }

  private checkWarning() {
    if (!this._earliest || !this._latest) {
      this.showOpenHoursWarning = false;
      this.showStandardHoursWarning = false;
      return;
    }

    let hasOpenHours = this.HasOpenHours();
    this.showOpenHoursWarning = hasOpenHours && !this.CheckBookingWindowFallsWithinOpenHours();

    this.showStandardHoursWarning =
      !hasOpenHours && !this.CheckBookingWindowFallsWithinStandardHours();
  }

  private CheckBookingWindowFallsWithinStandardHours() {
    let earliestHour = this._earliest.getHours();
    let latestHour = this._latest.getHours();
    let earliestStandardHour = 9;
    let latestStandardHour = 17;

    if (earliestHour < earliestStandardHour || earliestHour > latestStandardHour) {
      // earliest hour falls outside open hours
      return false;
    }
    if (latestHour < earliestStandardHour || latestHour > latestStandardHour) {
      // latest hour falls outside open hours
      return false;
    }
    return true;
  }

  private HasOpenHours(): boolean {
    if (this.openHours.length == 0) {
      return false;
    }
    if (this.openHours.every((x) => Number.isNaN(x.open))) {
      return false;
    }
    return true;
  }

  private CheckBookingWindowFallsWithinOpenHours(): boolean {
    let openHoursOnDayOfEarliest = this.openHours.find(
      (x) => x.dayOfWeek == this._earliest.getDay(),
    );
    let openHoursOnDayOfLatest = this.openHours.find((x) => x.dayOfWeek == this._latest.getDay());

    // opening hours are number of minutes past midnight so need to normalise to that form to compare.
    let earliestHourInMinutes = this._earliest.getHours() * 60 + this._earliest.getMinutes();
    let latestHourInMinutes = this._latest.getHours() * 60 + this._earliest.getMinutes();

    if (
      openHoursOnDayOfEarliest != null &&
      (earliestHourInMinutes < openHoursOnDayOfEarliest.open ||
        earliestHourInMinutes > openHoursOnDayOfEarliest.close)
    ) {
      // earliest hour falls outside open hours
      return false;
    }
    if (
      openHoursOnDayOfLatest != null &&
      (latestHourInMinutes < openHoursOnDayOfLatest.open ||
        latestHourInMinutes > openHoursOnDayOfLatest.close)
    ) {
      // latest hour falls outside open hours
      return false;
    }

    return true;
  }

  private ensureDate(value: string | Date | null): Date | null {
    if (!value) return null;
    const date = value instanceof Date ? value : new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }

  constructor() {}

  ngOnInit(): void {}
}
